<div>
  <div>
    <div class="row py-2" *ngIf="!isLoadingNutrition">
      <div class="col-md-auto col-12">
        <div class="h-100 d-flex align-items-center ">
        <h3 class="page-subtitle">Nutrition</h3>
        <button class="btn btn-primary btn-sm ml-3" data-toggle="modal"
        data-target="#createNutritionInfoModal">
          <span>
            <i class="fe fe-plus"></i>
            Add item
          </span>
        </button>
        </div>
      </div>
      <div class="col"></div>
      <div class="col-md-auto">
        <input
          type="text"
          class="px-3"
          placeholder="Search nutrient"
          id="searchBoxNutrition"
          (keyup)="filterNutritionFunction()">
      </div>
    </div>
    <div class="spinner d-block w-100 py-5 text-center" *ngIf="isLoadingNutrition">
      <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
    </div>
    <div *ngIf="!isLoadingNutrition">
      <table class="table table-primary table-bordered tab-dat">
        <thead>
          <tr class="text-uppercase">
            <th scope="col">#</th>
            <th scope="col">Nutrient Name</th>
            <th scope="col">Image</th>
            <th scope="col">Status</th>
            <th scope="col">About</th>
            <th scope="col">Defficiency Symptoms</th>
            <th scope="col">Defficiency Correction</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody class="cust-tab">
          <tr *ngIf="filterNutritionInfo?.length===0" style="text-align: center;">
            <td colspan="8">No nutrient added yet...</td>
          </tr>
          <tr *ngFor="let row of filterNutritionInfo | paginate: { id: 'paginate2', itemsPerPage: count, currentPage: nutPage };
          let i = index">
            <td>{{ (nutPage - 1) * count + i + 1 }}</td>
            <td>{{ row.name }}</td>
            <td>
              <div class="mult_images" *ngIf="row.media">
                <div *ngFor="let photo of row.media;">
                  <div class="img-holder" *ngIf="photo.photo_url">
                    <img src='{{ "https://storage.googleapis.com/ezyagric-media" + photo.photo_url }}' width="80" height="80" alt="{{ row.crop }}"
                    />
                  </div> 
                </div>
              </div>  
            </td>
            <td 
              [className]="row.status"
            >
              <span class="dot mr-2"></span>
              {{row.status | titlecase}}
            </td>
            <td [innerHTML]="row.roles | truncateText:5"></td>
            <td [innerHTML]="row.symptoms | truncateText:5"></td>
            <td [innerHTML]="row.prevention | truncateText:5"></td>
            <td>
              <div class="dropdown">
                <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  ACTION
                </button>
                <div class="dropdown-menu dropdown-menu-right options" aria-labelledby="dropdownMenuButton">
                  <button
                    class="dropdown-item suspend"
                    data-toggle="modal"
                    data-target="#editNutritionInfoModal"
                    (click)="editNutritionInfoDetails(row, 'false')"
                  >
                    View details
                  </button>
                  <button
                    *ngIf="checkPublishStatus('inactive',row)"
                    class="dropdown-item suspend text-success"
                    data-toggle="modal"
                    data-target="#publishModal"
                    (click)="editNutritionInfoDetails(row, 'true')"
                  >
                    Publish
                  </button>
                  <button
                    *ngIf="checkPublishStatus('active',row)"
                    class="dropdown-item suspend text-danger"
                    data-toggle="modal"
                    data-target="#publishModal"
                    (click)="editNutritionInfoDetails(row, 'true')"
                  >
                    Unpublish
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <nav aria-label="Nutrition nav">
        <pagination-controls id="paginate2" (pageChange)="nutPage = $event"></pagination-controls>
      </nav>
    </div>
  </div>

  <!-- Add Nutrition data  -->
  <div class="modal fade" id="createNutritionInfoModal" style="overflow: auto;">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document" (click)="onClickOutside()">
      <div class="card modal-content container-fluid">
          <div class="modal-header no-border">
            <h5 class="modal-title text text-primary" style="font-weight: bold;" id="modal-basic-title">Add Nutrition</h5>
            <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close" (click)="resetNutritionCreateModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body agronomical-view-details">
            <span class="text-center alert alert-danger" *ngIf="createNutritionError">{{ message }}</span>
            <div>
              <form
                [formGroup]="addNutritionForm" 
                (ngSubmit)="addNutrient()"
                id="addNutritionForm"
              >
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label for="purpose">Name</label>
                      <input 
                        type="text" 
                        class="form-control change-input-field" 
                        placeholder="Name" 
                        formControlName="name" 
                      />
                      <div
                        *ngIf="(addNutritionForm.get('name').dirty || addNutritionForm.get('name').touched)"
                        class="text-danger error_message"
                      >
                        <span *ngIf="addNutritionForm.get('name').invalid && addNutritionForm.get('name').errors.required">
                          Please the name is required
                        </span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="description">About Nutrient</label>
                        <quill-editor
                          formControlName="role"
                          [modules]="quillConfig"
                          [styles]="editorStyle"
                        >
                        </quill-editor>
                    </div>

                    <div class="form-group">
                      <label for="position">Position on app</label>
                      <input 
                        type="number" 
                        class="form-control" 
                        placeholder="Position nutrient should appear on app" 
                        formControlName="position" 
                      />
                      <div
                        *ngIf="(addNutritionForm.get('position').dirty || addNutritionForm.get('position').touched)"
                        class="text-danger error_message"
                      >
                        <span *ngIf="addNutritionForm.get('position').invalid && addNutritionForm.get('position').errors.required">
                          Please the position is required
                        </span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="description">Deficiency symptoms</label>
                        <quill-editor
                          formControlName="symptoms"
                          [modules]="quillConfig"
                          [styles]="editorStyle"
                        >
                        </quill-editor>
                    </div>

                    <div class="form-group">
                      <label for="description">Deficiency correction</label>
                        <quill-editor
                          formControlName="prevention"                       
                          [modules]="quillConfig"
                          [styles]="editorStyle"
                        >
                        </quill-editor>
                    </div>
                    <div class="form-group" *ngIf="countryName==='Uganda'">
                      <label for="inputs">Inputs</label>
                      <p-multiSelect
                        autoWidth="false"
                        [style]="{'width':'100%', 'height': '35px'}"
                        [options] = "inputsToSelect"
                        id="selectInput"
                        formControlName="input"
                      >
                      </p-multiSelect>
                    </div>
                    <div class="form-group">
                      <label for="inputs">Services</label>
                      <p-multiSelect
                        autoWidth="false"
                        [style]="{'width':'100%', 'height': '35px'}"
                        [options] = "servicesToSelect"
                        id="selectService"
                        formControlName="service"
                      >
                      </p-multiSelect>
                    </div>
                  </div>

                  <div class="col border-left">
                    <div class="form-group">
                      <label for="media">Media</label>
                      <div class="fert_logos">
                        <div formArrayName="media" *ngFor="let media of addNutritionMedia().controls; let i = index">
                          <div class="form-group" [formGroupName]="i">
                            <div class="card" style="width: 20rem;">
                              <div class="card-body">
                                <input 
                                  type="file" 
                                  class="form-control file-input"
                                  (change)="changeFiles($event, i)" 
                                  accept="image/png, image/jpeg, image/jpg" 
                                />
                                <br>
                                <div *ngIf="media.value.video_url">
                                  <video id='{{"add-vid-tag"+i}}' width="100%" height="150px" controls muted>
                                    <source src='{{ "https://storage.googleapis.com/ezyagric-media" + media.value.video_url }}'>
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                                <p-dropdown
                                  [options]="videosToSelect"
                                  formControlName="video_url"
                                  placeholder="Select a video"
                                  [optionLabel]="label"
                                  filter="true"
                                  [style]="{'width':'100%', 'height': '35px'}"
                                  (onChange)="onVideoChange($event, i)"
                                >
                                </p-dropdown>
                                <br>
                                <input 
                                  type="number" 
                                  class="form-control mt-3" 
                                  formControlName="position" 
                                  placeholder="Position"
                                >
                                <br>
                                <div class="row">
                                  <div class="col-md-3">
                                    <button 
                                      type="button" 
                                      class="btn btn-info btn-sm" 
                                      (click)="removeAddMedia(i)"
                                    >Remove</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div (click)="addMedia()" class="col">
                          <div class="card bg-light" id="add-card">
                            <div class="card-body text-center">
                              <i class="fas fa-plus"></i>
                              <p class="card-text">Add Media</p>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="logos">Fertilizers</label>
                      <div class="fert_logos">
                        <div formArrayName="fertilizer_logo" *ngFor="let logo of addFertilizerLogo().controls; let i = index">
                          <div class="form-group" [formGroupName]="i">
                            <div class="card" style="width: 20rem;">
                              <div class="card-body">
                                <input 
                                  class="form-control file-input" 
                                  type="file" 
                                  (change)="changeImage($event, i)" 
                                  accept="image/png, image/jpeg, image/jpg"
                                >
                                <br>
                                <input 
                                  type="text" 
                                  class="form-control" 
                                  formControlName="logo_name" 
                                  placeholder="Fertilizer Name"
                                  >
                                <br>
                                <input 
                                  type="number" 
                                  class="form-control" 
                                  formControlName="position" 
                                  placeholder="Position"
                                >
                                <br>
                                <div class="row">
                                  <div class="col-md-8">
                                    <input 
                                      type="number" 
                                      class="dose_units w-50" 
                                      formControlName="dose" 
                                      placeholder="Dose"
                                    >
                                    <input 
                                      type="text" 
                                      class="dose_units w-50" 
                                      formControlName="units" 
                                      placeholder="Units"
                                    >
                                  </div>
                                  <div class="col-md-3">
                                    <button 
                                      type="button" 
                                      class="btn btn-info btn-sm" 
                                      (click)="removeAddFertilizer(i)"
                                    >Remove</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div (click)="addFertilizer()" class="col">
                          <div class="card bg-light" id="add-card">
                            <div class="card-body text-center">
                              <i class="fas fa-plus"></i>
                              <p class="card-text">Add fertilizer</p>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              <br>
              <div>
                <button type="submit" class="btn btn-primary float-right" [disabled]="!addNutritionForm.valid">
                  <span *ngIf="loading" class="spinner-border spinner-border-sm
                    text-white change-loading" role="status"></span>
                  <span *ngIf="loading" class="mx-2">Loading...</span>
                  <span *ngIf="!loading">
                    Save changes
                  </span>
                </button>
              </div>
            </form>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- Beginning of edit nutrition data -->
  <div class="modal fade" id="editNutritionInfoModal" style="overflow: auto;">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document" (click)="onClickOutside()">
      <div class="card modal-content container-fluid">
          <div class="modal-header no-border">
              <h5 class="modal-title text text-primary" style="font-weight: bold;" id="modal-basic-title">Edit Nutrition</h5>
              <div class="float-right">
                <a
                  class="btn btn-danger text-white"
                  data-dismiss="modal"
                  data-toggle="modal"
                  data-target="#deleteNutritionModal"
                  (click)="deleteNutritionInfoDetails( editNutritionInfoData )"
                >Delete</a>
                <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close" (click)="resetNutritionEditModal()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
          </div>

          <div class="modal-body agronomical-view-details">
            <span class="text-center alert alert-danger" *ngIf="editNutritionError">{{ message }}</span>
            <div *ngIf="editNutritionInfoData">
              <form
                (ngSubmit)="updateNutritionInfo()"
                id="updateNutrition"
                [formGroup]="editNutritionForm" 
              >
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label for="purpose">Name</label>
                      <input 
                        type="text" 
                        class="form-control change-input-field" 
                        placeholder="Name" 
                        formControlName="name" 
                       />
                      <div
                        *ngIf="(editNutritionForm.get('name').dirty || editNutritionForm.get('name').touched)"
                        class="text-danger error_message"
                      >
                        <span *ngIf="editNutritionForm.get('name').invalid && editNutritionForm.get('name').errors.required">
                          Please the name is required
                        </span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="description">About Nutrient</label>
                        <quill-editor
                          formControlName="role"
                          [modules]="quillConfig"
                        >
                        </quill-editor>
                    </div>

                    <div class="form-group">
                      <label for="title">Current position on app</label>
                      <input 
                        type="number" 
                        class="form-control change-input-field"  
                        placeholder="Position on app"  
                        formControlName="position"  
                      />
                      <div
                        *ngIf="(editNutritionForm.get('position').dirty || editNutritionForm.get('position').touched)"
                        class="text-danger error_message"
                      >
                        <span *ngIf="editNutritionForm.get('position').invalid && editNutritionForm.get('position').errors.required">
                          Please the position is required
                        </span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="description">Deficiency symptoms</label>
                        <quill-editor
                          formControlName="symptoms"
                          [modules]="quillConfig"
                        >
                        </quill-editor>
                    </div>

                    <div class="form-group">
                      <label for="description">Deficiency correction</label>
                        <quill-editor
                          formControlName="prevention"
                          [modules]="quillConfig"
                        >
                        </quill-editor>
                    </div>
                    <div class="form-group" *ngIf="countryName==='Uganda'">
                      <label for="inputs">Inputs</label>
                      <p-multiSelect
                        autoWidth="false"
                        [style]="{'width':'100%', 'height': '35px'}"
                        [options] = "inputsToSelect"
                        id="selectInput"
                        formControlName="input"
                      >
                      </p-multiSelect>
                      <div
                        class="form-control reco-alert"
                        style="overflow: auto; min-height:120px;"
                        id="nutInputs"
                      >
                        <div
                          class="alert alert-primary alert-dismissible fade show"
                          style="width: 80%; padding: 2px;"
                          role="alert"
                          *ngFor="let input of savedInputs; let i = index"
                        >
                            {{ input.name }}
                          <button
                            type="button"
                            class="close close-btn"
                            data-dismiss="alert"
                            aria-label="Close"
                            (click) = "removeInput(i)"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="inputs">Services</label>
                      <p-multiSelect
                        autoWidth="false"
                        [style]="{'width':'100%', 'height': '35px'}"
                        [options] = "servicesToSelect"
                        id="selectService"
                        formControlName="service"
                      >
                      </p-multiSelect>
                      <div
                        class="form-control reco-alert"
                        style="overflow: auto; min-height:120px;"
                        id="nutServices"
                      >
                        <div
                          class="alert alert-primary alert-dismissible fade show"
                          style="width: 80%; padding: 2px;"
                          role="alert"
                          *ngFor="let service of editNutritionInfoData.service | falsyFilter; let i = index;"
                        >
                            {{ service }}
                          <button
                            type="button"
                            class="close close-btn"
                            data-dismiss="alert"
                            aria-label="Close"
                            (click) = "removeService(i)"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col border-left">
                    <div class="form-group">
                      <label for="media">Media</label>
                      <div class="fert_logos">
                        <div formArrayName="media" *ngFor="let media of editNutritionMedia().controls; let i = index">
                          <div class="form-group" [formGroupName]="i">
                            <div class="card" style="width: 20rem;">
                              <div class="card-body">
                                <div *ngIf="media.value.photo_url">
                                  <img
                                    class="card-img-top" 
                                    src='{{ "https://storage.googleapis.com/ezyagric-media" + media.value.photo_url }}'
                                    alt="nutrition image"
                                    style="width: 100%; height: 100px;"
                                  >
                                </div>
                                <input 
                                  type="file"   
                                  class="form-control file-input mt-1"
                                  (change)="changeFiles($event, i)" 
                                  accept="image/png, image/jpeg, image/jpg" 
                                />
                                <br>
                                <div *ngIf="media.value.video_url">
                                  <video id='{{"edit-vid-tag"+i}}' width="100%" height="150px" controls muted>
                                    <source src='{{ "https://storage.googleapis.com/ezyagric-media" + media.value.video_url }}'>
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                                <p-dropdown
                                  [options]="videosToSelect"
                                  formControlName="video_url"
                                  placeholder="Select a video"
                                  [optionLabel]="label"
                                  filter="true"
                                  [style]="{'width':'100%', 'height': '35px'}"
                                  (onChange)="onVideoChange($event, i)"
                                >
                                </p-dropdown>
                                <br>
                                <input 
                                  type="number" 
                                  class="form-control mt-3" 
                                  formControlName="position" 
                                  placeholder="Position"
                                >
                                <br>
                                <div class="row">
                                  <div class="col-md-3">
                                    <button 
                                      type="button" 
                                      class="btn btn-info btn-sm" 
                                      (click)="removeEditMedia(i)"
                                    >Remove</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div (click)="editMedia()" class="col">
                          <div class="card bg-light" id="add-card">
                            <div class="card-body text-center">
                              <i class="fas fa-plus"></i>
                              <p class="card-text">Add Media</p>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="logos">Fertilizers</label>
                      <div class="fert_logos">
                        <div formArrayName="fertilizer_logo" *ngFor="let logo of editFertilizerLogo().controls; let i = index">
                          <div class="form-group" [formGroupName]="i">
                            <div class="card" style="width: 20rem;">
                              <div *ngIf="logo.value.logo_image">
                                <img
                                  class="card-img-top" 
                                  src='{{ "https://storage.googleapis.com/ezyagric-media" + logo.value.logo_image }}'
                                  alt="logo image"
                                  style="width: 20rem; height: 100px;"
                                >
                              </div>
                              <div class="card-body">
                                <input 
                                  class="form-control file-input" 
                                  type="file" 
                                  (change)="changeImage($event, i)" 
                                  accept="image/png, image/jpeg, image/jpg" 
                                >
                                <br>
                                <input 
                                  type="text" 
                                  class="form-control" 
                                  formControlName="logo_name" 
                                  placeholder="Fertilizer Name"
                                  >
                                <br>
                                <input 
                                  type="number" 
                                  class="form-control" 
                                  formControlName="position" 
                                  placeholder="Position"
                                >
                                <br>
                                <div class="row">
                                  <div class="col-md-8">
                                    <input 
                                      type="number" 
                                      class="dose_units w-50" 
                                      formControlName="dose" 
                                      placeholder="Dose"
                                    >
                                    <input 
                                      type="text" 
                                      class="dose_units w-50" 
                                      formControlName="units" 
                                      placeholder="Units"
                                    >
                                  </div>
                                  <div class="col-md-3">
                                    <button 
                                      type="button" 
                                      class="btn btn-info btn-sm" 
                                      (click)="removeEditFertilizer(i)"
                                    >Remove</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div (click)="editFertilizer()" class="col">
                          <div class="card bg-light" id="add-card">
                            <div class="card-body text-center">
                              <i class="fas fa-plus"></i>
                              <p class="card-text">Add fertilizer</p>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              <div>
                <button type="submit" class="btn btn-primary float-right" [disabled]="!editNutritionForm.valid">
                  <span *ngIf="loading" class="spinner-border spinner-border-sm
                    text-white change-loading" role="status"></span>
                  <span *ngIf="loading" class="mx-2">Loading...</span>
                  <span *ngIf="!loading">
                    Save changes
                  </span>
                </button>
              </div>
            </form>
              </div>
          </div>
      </div>
    </div>
  </div>

  <!-- Beginning of delete nutrition modal -->
  <div class="modal fade" id="deleteNutritionModal">
    <div class="modal-dialog change-modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" *ngIf="deleteNutritionData">
        <div class="modal-header no-border">
          <h5 class="modal-title text-primary" id="exampleModalLabel">Delete Nutrient</h5>
          <button
            type="button"
            class="close close-btn"
            data-dismiss="modal"
            aria-label="Close"
            (click)="resetDeleteNutritionModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" *ngIf="deleteNutritionisSuccess" style="text-align: center; padding: 3rem 0 3rem 0;">
          <i class="far fa-check-circle fa-3x" style="color: teal; padding: 1rem 0 1rem 0"></i>
          <h4>Success!</h4>
          <p><span class="text-center">Nutrition info deleted successfully</span></p>
          <button class="btn btn-success px-3 filter-teal-bg text-white" data-dismiss="modal" (click)="resetDeleteNutritionModal()">OK</button>
      </div>
        <div class="modal-body" *ngIf="!deleteNutritionisSuccess">
          Are you sure you want to delete <span class="font-weight-bold">"{{ deleteNutritionData.name }}"</span> permanently?
        </div>
        <div class="modal-footer no-border" *ngIf="!deleteNutritionisSuccess">
          <span class="text-danger" *ngIf="deleteNutritionError">Some error occurred. Please try again</span>
          <button *ngIf="deleteNutritionError" class="btn btn-danger" data-dismiss="modal" (click)="resetDeleteNutritionModal()">OK</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button
            type="button"
            class="btn btn-danger"
            (click)="deleteNutrition(deleteNutritionData.id)"
          >
            <span
              *ngIf="loading"
              class="spinner-border spinner-border-sm text-white
                update-loading"
              role="status"
            ></span>
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</div>